import axios, {AxiosResponse} from 'axios'
import {ID, WoosatTelecomResponse, Response} from '../../../../../_metronic/helpers'
import {PaymentMethod, PaymentMethodsQueryResponse} from './_models'

const API_URL = process.env.REACT_APP_THEME_API_URL
const PAYMENTMETHOD_URL = `${API_URL}/admin/paymentmethods`
const GET_PAYMENTMETHODS_URL = `${API_URL}/admin/paymentmethods`

const getPaymentMethods = (query: string): Promise<PaymentMethodsQueryResponse | WoosatTelecomResponse<PaymentMethod[]>> => {
  return axios
    .get(`${GET_PAYMENTMETHODS_URL}?${query}`)
    .then((d: AxiosResponse<WoosatTelecomResponse<PaymentMethod[]>>) => {
      return d.data
    })
}

const getPaymentMethodById = async (id: ID): Promise<PaymentMethod> => {
  try {
    const {data} = await axios.get(`${PAYMENTMETHOD_URL}/${id}`)
    return data?.data?.paymentmethod
  } catch (error: any) {
    console.log('Error: ', error.message)
    return {}
  }
  // return axios.get(`${PAYMENTMETHOD_URL}/${id}`).then((response: AxiosResponse<PaymentMethod>) => response.data)
}
const createPaymentMethod = (paymentmethod: PaymentMethod): Promise<PaymentMethod | undefined> => {
  
  const formData = new FormData();
  Object.entries(paymentmethod).forEach(([key, value]) => {
    // Handle image separately
      formData.append(key, value);
  });

  return axios
    .post(PAYMENTMETHOD_URL, formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Set the content type to multipart/form-data
      },
    })
    .then((response: AxiosResponse<Response<PaymentMethod>>) => response.data)
    .then((response: Response<PaymentMethod>) => response.data)
}

const updatePaymentMethod = (paymentmethod: PaymentMethod): Promise<PaymentMethod | undefined> => {
  const newFormData = new FormData();
  Object.entries(paymentmethod).forEach(([key, value]) => {
    // Handle image separately
      newFormData.append(key, value);
  });
  // newFormData.append('_method','put');
  return axios
    .post(`${PAYMENTMETHOD_URL}/${paymentmethod.id}`, newFormData,{
      headers: {
        'Content-Type': 'multipart/form-data', // Set the content type to multipart/form-data
      },
    })
    .then((response: AxiosResponse<Response<PaymentMethod>>) => response.data)
    .then((response: Response<PaymentMethod>) => response.data)
}

const deletePaymentMethod = (paymentmethodId: ID): Promise<void> => {
  return axios.delete(`${PAYMENTMETHOD_URL}/${paymentmethodId}`).then(() => {})
}

const deleteSelectedPaymentMethods = (paymentmethodIds: Array<ID>): Promise<void> => {
  const requests = paymentmethodIds.map((id) => axios.delete(`${PAYMENTMETHOD_URL}/${id}`))
  return axios.all(requests).then(() => {})
}

export {
  getPaymentMethods,
  deletePaymentMethod,
  deleteSelectedPaymentMethods,
  getPaymentMethodById,
  createPaymentMethod,
  updatePaymentMethod,
}
